import { TeoCore } from '@/teoCore/TeoCore';
import type { TeoView } from '@/teoCore/text/TextUi';
import { useAtomValue } from '@/utils/jotai-svelte';
import {
  ActiveText$,
  onMountWithActiveText,
  teoActiveTextAtom,
  teoAtom,
} from '@/utils/teo-context/teoAtom';

// const ActiveTextUI$ = teoAtom((get) => get(ActiveText$).ui);

const ActiveTextUIView$ = teoAtom((get) => get(ActiveText$).store.state.view);
const ActiveTextUIPreviousView$ = teoAtom((get) => get(ActiveText$).store.state.previousView);
ActiveTextUIView$.onMount = onMountWithActiveText(({ refresh }, activeText) => {
  // refresh(); // sometimes this might be needed, it depends on the getter above
  return activeText.store.addEventListener('view', refresh);
});

const actions = {
  setSelectedUIView(view: TeoView) {
    TeoCore.instance.activeText?.store.setStateValue('view', view);
  },
};

export const useTextUIActions = () => actions;

export const useActiveTextUIViewValue = () => useAtomValue(ActiveTextUIView$);
export const useActiveTextUIPreviousViewValue = () => useAtomValue(ActiveTextUIPreviousView$);
export const useActiveTextUIView = () =>
  [useAtomValue(ActiveTextUIView$), actions.setSelectedUIView] as const;

// --- history ---
const History$ = teoActiveTextAtom((text) =>
  // create a new array identity
  [...text.history.entries],
);
History$.onMount = onMountWithActiveText(({ refresh }, text) => {
  refresh();
  return text.events.addEventListeners({
    gotAnalysis: refresh,
    historyChanged: () => {
      refresh();
    },
  });
});
export const useHistory = () => useAtomValue(History$);
